import { render, staticRenderFns } from "./ChessCell.vue?vue&type=template&id=6098849e&scoped=true&"
import script from "./ChessCell.vue?vue&type=script&lang=ts&"
export * from "./ChessCell.vue?vue&type=script&lang=ts&"
import style0 from "./ChessCell.vue?vue&type=style&index=0&id=6098849e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6098849e",
  null
  
)

export default component.exports